/** Shared shell dimensions — keep header height and drawer offset in sync. */
export const APP_HEADER_HEIGHT_CLASS = 'h-16';

/** Page wrapper inside `<main className="p-6">` — extends to main edges for full-bleed overlays. */
export const APP_PAGE_WRAPPER_CLASS = 'relative -m-6 min-h-full';

/** Overlay inside a page wrapper — fills main content below the app header. */
export const APP_MAIN_OVERLAY_CLASS = 'absolute inset-0 z-40';

/** Fixed overlay for drawers rendered outside a page wrapper. */
export const APP_DETAIL_OVERLAY_CLASS = 'fixed top-16 right-0 bottom-0 left-64 z-40';
